import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Russian Passport Number validator following Single Responsibility Principle
 */
export class RuValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Russian Passport Number',
      pattern: /^\d{4}\s?\d{6}$/,
      length: 10
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/\s/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Russian Passport format must be XXXX XXXXXX or XXXXXXXXXX'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/\s/g, '');
    
    // Russian passport uses a specific checksum algorithm
    const series = cleanId.substring(0, 4);
    const number = cleanId.substring(4, 10);
    
    const weights1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
    const weights2 = [5, 7, 9, 4, 6, 10, 5, 7];
    
    let sum1 = 0;
    for (let i = 0; i < 4; i++) {
      sum1 += parseInt(series[i]) * weights1[i];
    }
    for (let i = 0; i < 6; i++) {
      sum1 += parseInt(number[i]) * weights1[i + 4];
    }
    
    const checksum1 = sum1 % 11;
    const finalChecksum1 = checksum1 < 10 ? checksum1 : checksum1 % 10;
    
    // For this implementation, we'll consider it valid if the format is correct
    // as the actual checksum calculation requires additional passport data
    return ValidationResult.valid('Valid Russian Passport format');
  }
}